const geo = {
	latitude: "Breddegrad",
	longitude: "Lengdegrad"
};

export default geo;
export { geo };
